import React from 'react';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';

export function LoadingSkeleton() {
  return (
    <Grid container rowSpacing={2} columnSpacing={3} data-test="custom-reports-modal-loading-skeleton">
      <Grid item xs={12} md={6}>
        <Skeleton variant="rectangular" height={40} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Skeleton variant="rectangular" height={40} />
      </Grid>
      {Array.from({ length: 2 }).map((item, index) => (
        <Grid item xs={12} key={index}>
          <Skeleton variant="rectangular" height={40} />
        </Grid>
      ))}
      <Grid item xs={4}>
        <Skeleton variant="rectangular" height={40} />
      </Grid>
    </Grid>
  );
}
